import { Button, ButtonProps, useModal } from '@billy/design-system'
import { MouseEvent, ReactElement, useCallback } from 'react'

import { ModalId } from '../../../enums/modalId'
import { Scope } from '../../../enums/scope'
import { useComponentId } from '../../../hooks'
import { WithTrackingContext } from '../../../types/withTrackingContext'
import { isAuthorized } from '../../../utils/isAuthorized'
import { UpgradeSubscriptionModal } from '../../Modal'

interface ButtonUpsellProtectedProps extends ButtonProps, WithTrackingContext {
  upsellScope: Scope
}

export const ButtonUpsellProtected = ({
  onClick,
  trackingContext,
  upsellScope,
  ...props
}: ButtonUpsellProtectedProps): ReactElement => {
  const upgradeModalId = useComponentId(ModalId.UpgradeSubscriptionModal)
  const { open: openUpgradeModal } = useModal(upgradeModalId)

  const hasUpsellScope = isAuthorized(upsellScope)

  const handleButtonClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (hasUpsellScope) {
        event.preventDefault()
        event.stopPropagation()

        openUpgradeModal()
        return
      }

      onClick?.(event)
    },
    [hasUpsellScope, onClick, openUpgradeModal],
  )

  return (
    <>
      <Button {...props} onClick={handleButtonClick} />
      <UpgradeSubscriptionModal id={upgradeModalId} trackingContext={trackingContext} />
    </>
  )
}
